export default "__VITE_ASSET__wmGa_1Zx__"